import React from "react";
import {FormattedMessage} from "react-intl";

import {blueColor} from "../../../../../../assets/jss/main";

const styles = {
    orderId: {
        fontWeight: 600,
        color: blueColor,
    },
};

export default function ActionLog({order}) {
    return (
        <FormattedMessage
            id="picking.order.show.note.automaticLog.action"
            values={{
                orderId: <span style={styles.orderId}>#{order?.externalId}</span>,
            }}
        />
    );
}
